// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginForm_formContainer__vSbuj","form":"LoginForm_form__TbM3q","title":"LoginForm_title__12pvm","logInButton":"LoginForm_logInButton__aX7Pl"};